import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
        height: "100%",
        position: "relative",
        display: loading => loading ? "block" : "none"
    },
    circle: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }
}));
export default function Loading(props) {
    const { color = "primary", isLoading, error, pastDelay, timedOut } = props;
    const classes = useStyles(!!isLoading);
    let renderComponents = <></>;
    if (error) {
        renderComponents = (<div>Error!</div>);
    }
    else if (pastDelay) {
        renderComponents = (<CircularProgress className={classes.circle} color={color}/>);
    }
    else if (timedOut) {
        renderComponents = (<div>Time out...</div>);
    }
    return (<div className={classes.root}>
      {renderComponents}
    </div>);
}
